/* This file is autogenerated, see readme.md for instructions */
import CloudDownloadSvgIcon from '@bloomreach/banana-theme/icons/cloud-download.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CloudDownloadIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CloudDownloadSvgIcon />
    </Icon>
  );
});

CloudDownloadIcon.displayName = 'CloudDownloadIcon';

export default CloudDownloadIcon;
